import React from 'react';
import './feature.css';

const Feature = ({ title, text, icon, color }) => (
  <div className="feature-card">
    <div className="feature-card-header">
      <div className="feature-icon-container" style={{ backgroundColor: color + '20' }}>
        <div className="feature-icon-wrapper" style={{ color: color }}>
          {icon}
        </div>
      </div>
      <div className="feature-title-container">
        <div className="feature-title-bar" style={{ backgroundColor: color }}></div>
        <h3 className="feature-title">{title}</h3>
      </div>
    </div>
    <div className="feature-content">
      <p className="feature-text">{text}</p>
    </div>
  </div>
);

export default Feature;